<template>
    <article :id="`post-${post.id}`" class="post-card">
        <div class="post-card-media">
            <div v-if="!!post?.media.length" class="post-thumbnail">
                <NuxtLinkLocale
                    :to="{
                        name: 'news-slug',
                        params: {
                            slug: post?.slug
                        }
                    }"
                    :title="post?.title"
                >
                    <UiImage :src="post?.media[0].webp" :classes="'responsive full'" />
                </NuxtLinkLocale>
            </div>
            <div v-show="!!post.newsGroup.length" class="post-category">
                <div v-for="tag in post.newsGroup" :key="tag.id" class="tag">{{ tag.title }}</div>
            </div>
        </div>
        <h6 class="post-card--title">{{ post.title }}</h6>
    </article>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        post?: CmsItem;
    }>(),
    {
        post: () => ({})
    }
);

const post = computed(() => props.post);
</script>
